import { CaptionSettingsItem } from '../../types';

export function getCaptionSettingsList(): Array<CaptionSettingsItem> {
  return [
    {
      id: 1,
      fontSize: '100%',
      fontColor: [255, 255, 255],
      backgroundColor: [0, 0, 0],
      backgroundOpacity: 0.5,
    },
    {
      id: 2,
      fontSize: '200%',
      fontColor: [255, 255, 255],
      backgroundColor: [0, 0, 0],
      backgroundOpacity: 0.5,
    },
    {
      id: 3,
      fontSize: '200%',
      fontColor: [255, 255, 0],
      backgroundColor: [0, 0, 0],
      backgroundOpacity: 0.5,
    },
  ];
}
